import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatListModule } from '@angular/material/list';
import { CmsConfig, DeferLoadingStrategy, provideConfig } from '@spartacus/core';
import { SharedModule } from 'src/app/shared/shared.module';
import { CustomerServiceSectionComponent } from './customer-service-section.component';

@NgModule({
  declarations: [CustomerServiceSectionComponent],
  imports: [CommonModule, MatListModule, SharedModule],
  providers: [
    provideConfig(<CmsConfig>{
      cmsComponents: {
        ShimanoCustomerServiceSectionComponent: {
          component: CustomerServiceSectionComponent,
          deferLoading: DeferLoadingStrategy.DEFER,
        },
      },
    }),
  ],
  exports: [CustomerServiceSectionComponent],
})
export class CustomerServiceSectionModule {}
